export const constantsMixin = (constants) => ({
  created() {
    Object.keys(constants).forEach((cName) => {
      this[cName] = constants[cName];
    });
  },
});

export default { constantsMixin };
